import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const ButtonRow = ({ children, space, className, qaId }) => {
  const buttonRowClass = classNames({
    'uni-btn__row': !space,
    [`uni-btn__row--${space}`]: space,
    [className]: className,
  });

  return (
    <div className={buttonRowClass} data-qa-id={qaId}>
      {children}
    </div>
  );
};

ButtonRow.propTypes = {
  space: PropTypes.oneOf(['eighth', 'quarter', 'half', 'one', 'one-and-half', 'two', 'three', 'four']),
  children: PropTypes.node,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

ButtonRow.defaultProps = {
  space: 'half',
  classname: '',
};

export default ButtonRow;



// WEBPACK FOOTER //
// ./src/buttons/button-row/index.jsx